import { render, staticRenderFns } from "./ConfectionProductionReporting.vue?vue&type=template&id=16cff588&"
import script from "./ConfectionProductionReporting.vue?vue&type=script&lang=js&"
export * from "./ConfectionProductionReporting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports